<template>
    <div class="receipt-seal-info">
        <h3>签回要求</h3>
        <div class="image-box">
            <el-carousel v-if="receiptSealInfo.files.length" class="el-carousel-image" trigger="click" height="180px" @change="setReceiptSealImage">
                <el-carousel-item v-for="item in receiptSealInfo.files" :key="item.id" class="image-item">
                    <img :src="item.path" width="180px" height="180px">
                </el-carousel-item>
            </el-carousel>
            <div v-else class="el-carousel-image" height="180px" style="line-height: 180px;">暂 无 图 片 信 息 数 据</div>
            <div class="tools-bar" v-if="receiptSealInfo.files.length">
                <span class="icon" @click="imageDialogVisible = true"><i class="el-icon-zoom-in"></i></span>
                <span class="icon" @click="downloadReceiptSealImage"><i class="el-icon-download"></i></span>
            </div>
        </div>
        <p class="days">
            <span>回单时效类型：</span>
            <span class="agingType">{{+receiptSealInfo.agingType === 1 ? '自然月' : '固定天数' }}</span>
            签回时效：
            <span class="text-red">{{ receiptSealInfo.aging }}天</span>
            <el-tooltip class="item" effect="dark" content="按要求上传回单，可以提升结算回款及时率" placement="right">
                <i class="el-icon-info el-icon-red"></i>
            </el-tooltip>
        </p>
        <div class="tags">
            <el-tag
                type="warning"
                size="medium"
                v-for="(item, index) in receiptSealInfo.signRequest"
                :key="index">{{ item }}
            </el-tag>
        </div>
        <el-dialog :visible.sync="imageDialogVisible" append-to-body>
            <img width="100%" :src="receiptSealImage" alt="">
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'signAsk',
    props: {
        receiptSealInfo: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            imageDialogVisible: false,
            receiptSealImage: ''
        };
    },
    methods: {
        setReceiptSealImage (index) {
            this.receiptSealImage = this.receiptSealInfo.files[index].path;
        },
        downloadReceiptSealImage () {
            window.location = this.receiptSealImage;
        }
    },
    mounted () {
        this.receiptSealImage = this.receiptSealInfo.files.length ? this.receiptSealInfo.files[0].path : '';
    }
};
</script>
<style lang="less">
.receipt-seal-info {
    h3 {
        margin-bottom: 5px;
    }
    .image-box {
        height: 200px;
        border: 1px solid #ddd;
        border-radius: 6px;
        text-align: center;
        padding: 10px 0;
        .el-carousel-image {
            height: 180px;
            width: 140px;
            display: inline-block;
            .image-item {
                width: 100%;
                height: 100%
            }
        }
        .tools-bar {
            margin-top: 8px;
            .icon {
                font-size: 16px;
                padding: 0 5px;
                cursor: pointer;
            }
        }
    }
    .days {
        text-align: center;
        font-size: 13px;
        .text-red {
            color: #F56C6C;
        }
        .el-icon-red {
            padding-left: 10px;
            color: #F56C6C;
            font-size: 16px;
        }
        .agingType{
            margin-right: 10px;
            color: #F56C6C;
        }
    }
    .tags {
        text-align: center;
        span {
            margin-right: 10px;
        }
    }
}
</style>
